import _ from "lodash";
import React, { useEffect } from "react";
import { EEScorecard } from "../../../../../Component/Model/Dto/EmploymentEquity/EEScorecard";
import { Individual } from "../../../../../Component/Model/Dto/Individual";
import { defaultObject } from "../../../../../Helpers/typescriptHelper";
import { EntriesPerPage } from "../../../../../Component/Model/Table/Table";
import { PeopleDtos } from "../../../../../Component/Model/Dto/People";
import { useRecoilValue } from "recoil";
import { ConsolidationAtom } from "../../../../../State/Consolidation.Atom";
import { ColumnSortOption, SortDirections } from "../../../../../Component/Model/Dto/ColumnSortOption";
import { DateToString } from "../../../../../Component/Model/helpers";
import { IndividualService } from "../../../../../Component/Api/Individual/IndividualService";
import { ExportKeyValue } from "../../../../../Component/Model/Dto/Upload";
import { IFilter } from "../../../../../Component/Common/Components/DataTable/Filters";
import { EmployeeSalariesConsolidationWithActionsTableMapper_Old, EmployeeSalariesWithActionsTableMapper_Old } from "./EmployeeSalariesColumnsOld";
import { EmployeeSalariesDataTable } from "../EmployeeSalariesDataTable";
import { EmployeeModal } from "../../EmployeeModal";
import { ImportExportButtonsDialog } from "../../../../Common/ImportAndExport/ImportExportButtonsDialog";
import { DataImportType } from "../../../../../Component/Model/Enum/BEE123Enums";
import { IndividualSalaryModal_Old } from "../../../../Common/Individual/Old/IndividualSalaryModalOld";
import { EE123SalariesRole_Edit, UserAdminRole } from "../../../../../Component/Common/Constants/UserRoles";
import { userRolesState } from "../../../../../State/user.Atom";


interface IProps {
    scorecardId: string;
    GenderIds?: Array<number>;
    RaceIds?: Array<number>;
    OccupationIds?: Array<number>;
    scorecard: EEScorecard.DtoOut;
    hasFilters: boolean;
    filterByDate: boolean;
    filterDate: Date;
}

export const EmployeeSalariesTableWithActions_Old = (props: IProps) => {
    const [employeeSalariesData, setEmployeeSalariesData] = React.useState<Individual.SalarySummaryDtoIn[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = React.useState<number>(0);
    const [showIndividualModal, setShowIndividualModal] = React.useState<boolean>(false);
    const [showEmployeeModal, setShowEmployeeModal] = React.useState<boolean>(false);
    const link = 'IndividualRow';
    const [person, setPerson] = React.useState<PeopleDtos.GetPersonRequest | null>(null);
    const isConsolidateScorecard = useRecoilValue(ConsolidationAtom);
    const editRoleAccess = [
        EE123SalariesRole_Edit,
        UserAdminRole
    ];
    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [searchValue, setSearchValue] = React.useState<string>('');
    const [sortColumnNames, setSortColumnNames] = React.useState<string[]>([]);
    const [sortDirections, setSortDirections] = React.useState<SortDirections[]>([]);
    const [filters, setFilters] = React.useState<any>();
    const [filterCount, setFilterCount] = React.useState(0);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setSortColumnNames([sortOption.ColumnName]);
        setSortDirections([sortOption.SortDirection]);
        setPageNumber(1);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let individualsSearchRequest: Individual.SalarySummarySearchRequest = {
                Draw: 2,
                PageNumber: pageNumber,
                PageSize: entriesPerPage.defaultValue!,
                ScorecardId: props.scorecardId,
                SearchValue: searchValue,
                SortColumnNames: sortColumnNames,
                SortDirections: sortDirections,
                FilterByDate: props.filterByDate,
                UserSelectedDate: DateToString(props.filterDate),
                GenderIds: props.GenderIds,
                OccupationIds: props.OccupationIds,
                RaceIds: props.RaceIds,
                DisabledValues: [],
                IsYesAbsorbed: [],
                IsYesEmployee: []
            };
            individualsSearchRequest = { ...individualsSearchRequest, ...filters };

            let filteredRequest = individualsSearchRequest;
            if (filteredRequest.RaceIds?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["RaceIds"]);
            }

            if (filteredRequest.GenderIds?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["GenderIds"]);
            }

            if (filteredRequest.OccupationIds?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["OccupationIds"]);
            }

            if (filteredRequest.DisabledValues?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["DisabledValues"]);
            }

            if (filteredRequest.IsYesAbsorbed?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["IsYesAbsorbed"]);
            }

            if (filteredRequest.IsYesEmployee?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["IsYesEmployee"]);
            }

            if (filteredRequest.ProvinceTypeIds?.length === 0) {
                filteredRequest = _.omit(filteredRequest, ["ProvinceTypeIds"]);
            }

            let searchResult = await IndividualService.SummarySearchIndividualsSalary(filteredRequest);
            if (searchResult.data) {
                setEmployeeSalariesData(searchResult.data.dataObject);
                setFilteredItemsCount(searchResult.data.filteredItemsCount);
                setTotalItemsCount(searchResult.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error);
            setEmployeeSalariesData(defaultObject);
            setFilteredItemsCount(1);
            setTotalItemsCount(1);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (id: number) => {
        setSelectedEmployeeId(id);
        setShowIndividualModal(true);
    }

    const closeIndividualModal = () => {
        setShowIndividualModal(false);
        setSelectedEmployeeId(0);
        fetchData();
    }

    const closeEmployeeModal = () => {
        setShowEmployeeModal(false);
        setSelectedEmployeeId(0);
        fetchData();
    }

    const afterEmployeeSave = (id: number) => {
        handleEdit(id);
        setShowEmployeeModal(false);
    }

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue, sortColumnNames, sortDirections, props.filterDate, filterCount]); // eslint-disable-line react-hooks/exhaustive-deps

    const parameters: ExportKeyValue[] = [
        {
            key: "FilterDate",
            value: props.filterDate
        }
    ];

    const employeeSalariesFilters: Array<IFilter> = [
        {
            label: 'Gender:',
            values: [{ key: 'Male', val: 1 }, { key: 'Female', val: 2 }],
            type: 1, propname: 'GenderIds',
        },
        {
            label: 'Race:',
            values: [{ key: 'African', val: 1 }, { key: 'Coloured', val: 2 }, { key: 'Indian', val: 3 }, { key: 'White', val: 4 }, { key: 'Non South African', val: 5 }],
            type: 1, propname: 'RaceIds',
        },
        {
            label: 'Occupation Level:',
            values: [{ key: 'Executive Director', val: 1 },
            { key: 'Other Executive Management', val: 4 },
            { key: 'Senior Management', val: 5 },
            { key: 'Middle Management', val: 6 },
            { key: 'Junior Management', val: 7 },
            { key: 'Semi skilled', val: 8 },
            { key: 'Unskilled', val: 9 }],
            type: 1, propname: 'OccupationIds'
        },
        {
            label: 'Disabled:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: 1, propname: 'DisabledValues'
        },
        {
            label: 'Province:',
            values: [
                { key: 'Unspecified', val: 0 },
                { key: 'National (NAT)', val: 1 },
                { key: 'Eastern Cape (EC)', val: 2 },
                { key: 'Free State (FS)', val: 3 },
                { key: 'Gauteng (GP)', val: 4 },
                { key: 'KwaZulu-Natal (KZN)', val: 5 },
                { key: 'Limpopo (LP)', val: 6 },
                { key: 'Mpumalanga (MP)', val: 7 },
                { key: 'North West (NW)', val: 8 },
                { key: 'Northern Cape (NC)', val: 9 },
                { key: 'Western Cape (WC)', val: 10 },
            ],
            type: 1, propname: 'ProvinceTypeIds'
        },
        {
            label: 'Y.E.S. Employee:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: 1, propname: 'IsYesEmployee'

        },
        {
            label: 'Y.E.S. Absorbed:',
            values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
            type: 1, propname: 'IsYesAbsorbed'
        }
    ];

    const filtersChanged = (filterProps: any) => {
        setFilters(filterProps);
        setPageNumber(1);
        setFilterCount(filterCount + 1);
    }

    let employeeTableData = undefined;
    if (isConsolidateScorecard) {
        employeeTableData = EmployeeSalariesConsolidationWithActionsTableMapper_Old(employeeSalariesData, handleEdit, isEditable);
    } else {
        employeeTableData = EmployeeSalariesWithActionsTableMapper_Old(employeeSalariesData, handleEdit, isEditable);
    }

    return (
        <>
            <EmployeeSalariesDataTable
                employeeSalariesData={employeeTableData!}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                columnSortingChanged={columnSortingChanged}
                isLoading={isLoading}
                hasFilters={props.hasFilters}
                employeeSalariesFilters={employeeSalariesFilters}
                filtersChanged={filtersChanged}
            />

            {showIndividualModal && <IndividualSalaryModal_Old showIndividualModal={showIndividualModal} closeIndividualModal={closeIndividualModal} scorecardId={props.scorecardId} id={selectedEmployeeId} />}

            {showEmployeeModal && <EmployeeModal scorecardId={props.scorecardId} person={person} afterSaved={afterEmployeeSave} showEmployeeModal={showEmployeeModal} closeEmployeeModal={closeEmployeeModal} />}

            {<ImportExportButtonsDialog scorecardId={props.scorecardId}
                uploadType={DataImportType[DataImportType.Salary]}
                controlsEnabled={true}
                showHelpfileDownload={true}
                importBus={false}
                coreExportEnabled={true}
                coreImportEnabled={true}
                type={"Salary"}
                typeId={DataImportType.Salary}
                parameters={parameters}
                reloadTable={fetchData}
                showYearToAdd={true}
                showAdditionalParamsModal={true} />}
        </>
    )
}
